<template>
  <v-row>

    <v-col cols="12">
      <v-sheet 
        outlined>

        <v-row class="pt-4 pl-4 pr-4">
          <v-col cols="12">
            <v-select
              :items="type_postulations"
              v-model="type_postulations_id"
              item-text="name"
              item-value="id"
              label="Tipo"
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
        
    <v-col cols="12">
      <v-sheet 
        outlined>

        <v-row class="pa-4" v-if="type_postulations_id==1 || type_postulations_id==2">

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de la Idea</h2>
            <label class="text--secondary">Podés ir completado de forma parcial y guardando con el botón ACTUALIZAR al pie de este formulario </label>
          </v-col>

          <v-col cols="12">

            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la idea no debe tener mas de 200 caracteres']"
              ref="title"
              outlined
              v-model="title"
              label="Mi idea*"
              required
            ></v-text-field>
            
            <v-textarea
              :maxlength="300"
              :counter="300"
              :rules="[v => (v || '' ).length <= 299 || 'La descripción no debe tener mas de 300 caracteres']"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Breve descripción del proyecto*"
            ></v-textarea>

            <v-select
              :items="vertical_works"
              v-model="vertical_works_id"
              item-text="name"
              item-value="id"
              label="Vertical de trabajo*"
              outlined
            ></v-select>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El equipo  no debe tener mas de 1500 caracteres']"
              outlined
              ref="team"
              name="team"
              v-model="team"
              label="Equipo emprendedor (integrantes, roles, aportes)*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Los beneficiarios/clientes/usuarios no debe tener mas de 1500 caracteres']"
              outlined
              ref="beneficiary_clients_users"
              name="beneficiary_clients_users"
              v-model="beneficiary_clients_users"
              label="Beneficiarios/Clientes/Usuarios*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El problema no debe tener mas de 1500 caracteres']"
              outlined
              ref="problem"
              name="problem"
              v-model="problem"
              label="Problema*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La solición propuesta no debe tener mas de 1500 caracteres']"
              outlined
              ref="solution"
              name="solution"
              v-model="solution"
              label="Solución*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La Innovación/Valor agregado no debe tener mas de 1500 caracteres']"
              outlined
              ref="innovation"
              name="innovation"
              v-model="innovation"
              label="Innovación/Valor agregado*"
            ></v-textarea>

            <v-select
              :items="development_degree_ip"
              v-model="development_degree_ip_id"
              item-text="name"
              item-value="id"
              label="Grado de desarrollo actual de la Idea*"
              outlined
            ></v-select>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El plan de acción no debe tener mas de 1500 caracteres']"
              outlined
              ref="action_plan"
              name="action_plan"
              v-model="action_plan"
              label="Plan de Acción*"
            ></v-textarea>

            <v-row class="pb-8">
              <v-col cols="12">
                <h2 class="font-weight-light">Antecedentes</h2>
                <label class="text--secondary"> Contanos los avances y logros de la startup agregándolos aquí</label>
              </v-col>

              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left" width="20%">
                        Tipo
                      </th>
                      <th class="text-left" width="60%">
                        Name
                      </th>
                      <th class="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in curriculum_idea"
                      :key="index"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.description }}</td>
                      <td class="text-center">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="red"
                          @click="deleteMileston(index)"
                        >
                          <v-icon dark>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_hito=true"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar
                </v-btn>
              </v-col>
            </v-row>

          </v-col>

          <template v-if="type_postulations_id==2">
            <v-col cols="12">
              <h2 class="font-weight-light">Datos de la Insticución:</h2>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                :maxlength="200"
                :counter="200"
                :rules="[v => (v || '' ).length <= 199 || 'El nombre de la escuela no debe tener mas de 200 caracteres']"
                ref="title"
                outlined
                v-model="name_school"
                label="Nombre de la escuela*"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                :maxlength="200"
                :counter="200"
                :rules="[v => (v || '' ).length <= 199 || 'La dirección no debe tener mas de 200 caracteres']"
                ref="title"
                outlined
                v-model="address_school"
                label="Dirección de la institución*"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                :maxlength="200"
                :counter="200"
                :rules="[v => (v || '' ).length <= 199 || 'La dirección no debe tener mas de 200 caracteres']"
                ref="title"
                outlined
                v-model="phone_number_school"
                label="Telefono de la institución*"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <v-text-field
                :maxlength="200"
                :counter="200"
                :rules="[v => (v || '' ).length <= 199 || 'La dirección no debe tener mas de 200 caracteres']"
                ref="title"
                outlined
                v-model="email_school"
                label="Correo electrónico*"
                required
              ></v-text-field>
            </v-col>
          </template>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="countries"
              v-model="country_id"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="provincias"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="localidades"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <label class="text--secondary text--danger">Los campos señalados con * son obligatorios</label>
          </v-col>
        </v-row>

        <v-row class="pa-4" v-if="type_postulations_id==3">
          <v-col cols="12">
            <h2 class="font-weight-light">Datos del Modelo de Negocio</h2>
            <label class="text--secondary">Podés ir completado de forma parcial y guardando con el botón ACTUALIZAR al pie de este formulario </label>
          </v-col>

          <v-col cols="12">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la idea no debe tener mas de 200 caracteres']"
              ref="title"
              outlined
              v-model="title"
              label="Mi idea*"
              required
            ></v-text-field>
            
            <v-textarea
              :maxlength="300"
              :counter="300"
              :rules="[v => (v || '' ).length <= 299 || 'La breve descripción del proyecto no debe tener mas de 200 caracteres']"
              outlined
              ref="description"
              name="description"
              v-model="description"
              label="Breve descripción del proyecto*"
            ></v-textarea>

            <v-select
              :items="vertical_works"
              v-model="vertical_works_id"
              item-text="name"
              item-value="id"
              label="Vertical de trabajo*"
              outlined
            ></v-select>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El equipo emprendedor no debe tener mas de 1500 caracteres']"
              outlined
              ref="team"
              name="team"
              v-model="team"
              label="Equipo emprendedor (integrantes, roles, aportes)*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El problema detectado no debe tener mas de 1500 caracteres']"
              outlined
              ref="problem"
              name="problem"
              v-model="problem"
              label="Problema*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La solición propuesta no debe tener mas de 1500 caracteres']"
              outlined
              ref="solution"
              name="solution"
              v-model="solution"
              label="Solución*"
            ></v-textarea>

            <v-textarea
              :maxlength="2000"
              :counter="2000"
              :rules="[v => (v || '' ).length <= 1999 || 'El mercado no debe tener mas de 2000 caracteres']"
              outlined
              ref="market"
              name="market"
              v-model="market"
              label="Mercado y segmentos de clientes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El servicio o producto que ofrece no debe tener mas de 1500 caracteres']"
              outlined
              ref="value_proposal"
              name="value_proposal"
              v-model="value_proposal"
              label="Propuesta de Valor*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Los canales y relación con clientes no debe tener mas de 1500 caracteres']"
              outlined
              ref="channels_with_customers"
              name="channels_with_customers"
              v-model="channels_with_customers"
              label="Canales y relación con clientes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'El modelo de ingresos no debe tener mas de 1500 caracteres']"
              outlined
              ref="revenue_model"
              name="revenue_model"
              v-model="revenue_model"
              label="Modelo de ingresos*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'Las actividades y recursos claves no debe tener mas de 1500 caracteres']"
              outlined
              ref="activities_resources"
              name="activities_resources"
              v-model="activities_resources"
              label="Actividades y recursos claves*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La inversión y estructura de costos no debe tener mas de 1500 caracteres']"
              outlined
              ref="investment_cost"
              name="investment_cost"
              v-model="investment_cost"
              label="Inversión y Estructura de costos*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'La competencia y soluciones alternativas existentes no debe tener mas de 1500 caracteres']"
              outlined
              ref="competence"
              name="competence"
              v-model="competence"
              label="Competencia y soluciones alternativas existentes*"
            ></v-textarea>

            <v-textarea
              :maxlength="1500"
              :counter="1500"
              :rules="[v => (v || '' ).length <= 1499 || 'el impacto esparado no debe tener mas de 1500 caracteres']"
              outlined
              ref="expected_impact"
              name="expected_impact"
              v-model="expected_impact"
              label="Impacto esparado*"
            ></v-textarea>

            <v-row>
              <v-col cols="12" xl="6" md="6" sm="12">
                <v-select
                  :items="development_degree_mdn"
                  v-model="development_degree_mdn_id"
                  item-text="name"
                  item-value="id"
                  label="Grado de desarrollo actual*"
                  outlined
                ></v-select>
              </v-col>

              <v-col cols="12" xl="6" md="6" sm="12">
                <v-select
                  :items="entrepreneurship_stadium"
                  v-model="entrepreneurship_stadia_id"
                  item-text="name"
                  item-value="id"
                  label="¿Como se encuentra el proyecto?*"
                  outlined
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <h2 class="font-weight-light">Antecedentes</h2>
                <label class="text--secondary"> Contanos los avances y logros de la startup agregándolos aquí</label>
              </v-col>

              <v-col cols="12">
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left" width="20%">
                        Tipo
                      </th>
                      <th class="text-left" width="60%">
                        Name
                      </th>
                      <th class="text-center">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in curriculum_idea"
                      :key="index"
                    >
                      <td>{{ item.type }}</td>
                      <td>{{ item.description }}</td>
                      <td class="text-center">
                        <v-btn
                          fab
                          dark
                          x-small
                          color="red"
                          @click="deleteMileston(index)"
                        >
                          <v-icon dark>
                            mdi-trash-can-outline
                          </v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>

              <v-col cols="12" class="text-center">
                <v-btn 
                  outlined
                  @click="add_hito=true"
                  color="primary">
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <h2 class="font-weight-light">Datos de radicación:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-select
              :items="countries"
              v-model="country_id"
              item-text="name"
              item-value="id"
              label="Pais*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="provincias"
              v-model="provincia_id"
              v-on:change="getLocalidades"
              item-text="name"
              item-value="id"
              label="Provincia*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre del estado/provincia no debe tener mas de 200 caracteres']"
              ref="other_provincia"
              outlined
              v-model="other_provincia"
              label="Estado/provincia"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id==argentina_id">
            <v-select
              :items="localidades"
              v-model="localidad_id"
              item-text="name"
              item-value="id"
              label="Localidad*"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12" v-if="country_id!=argentina_id">
            <v-text-field
              :maxlength="200"
              :counter="200"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la localidad no debe tener mas de 200 caracteres']"
              ref="other_localidad"
              outlined
              v-model="other_localidad"
              label="Localidad"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <label class="text--secondary text--danger">Los campos señalados con * son obligatorios</label>
          </v-col>

        </v-row>

      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined 
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Información del responsable del Emprendimiento:</h3>
          </v-col>

          <v-col
            cols="12"
            xl="4"
            md="4"
            sm="12"
          >
            <v-text-field
              :maxlength="50"
              :counter="50"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la edición no debe tener mas de 200 caracteres']"
              v-model="name"
              outlined
              label="Nombre*"
              required
            ></v-text-field>
            
          </v-col>

          <v-col
            cols="12"
            xl="4"
            md="4"
            sm="12"
          >
            <v-text-field
              :maxlength="50"
              :counter="50"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la edición no debe tener mas de 200 caracteres']"
              v-model="lastname"
              outlined
              label="Apellido*"
              required
            ></v-text-field>
            
          </v-col>

          <v-col
            cols="12"
            xl="4"
            md="4"
            sm="12"
          >
            <v-text-field
              :maxlength="50"
              :counter="50"
              :rules="[v => (v || '' ).length <= 199 || 'El nombre de la edición no debe tener mas de 200 caracteres']"
              v-model="email"
              outlined
              label="Correo eletrónico*"
              required
            ></v-text-field>
            
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-8 d-flex justify-space-between">
      <v-btn
        depressed
        class="mr-auto mt-2"
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        :to="{ name: 'entrepreneurshipsEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>


      <v-btn
        :loading="loading"
        depressed
        class="mt-2"
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        @click="confirm_dialog=true"
        >
        <v-icon left>
          mdi-plus
        </v-icon>
        Agregar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="confirm_dialog"
      persistent
      max-width="490">
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>

          <p>
            Se enviara un correo eletrónico al responsable del emprendimiento con
            la contraseña de acceso. La Idea/Modelo de negocio aparece como aceptada
            y el responsable podra editar su Stand y agregar al resto de integrantes del
            equipo emprendedor.
          </p>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="confirm_dialog = false"
          >
            Cerrar
          </v-btn>

          <v-btn
            color="primary darken-1"
            text
            @click="createInvitation()"
          >
            Enviar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_error"
      persistent
      max-width="490">
      <v-card>
        <v-card-title class="text-h5">
          Advertencia
        </v-card-title>
        <v-card-text>
          <v-list-item 
            v-for="e in errors" 
            v-bind:key="e">
            - {{ e }}
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="error = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="add_hito"
      persistent
      max-width="700px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Antecedentes:</span>
        </v-card-title>
        <v-card-text>

            <v-row>
              <v-col
                cols="12"
                class="pt-9"
              >
                <v-select
                  v-model="milestone_type"
                  :items="['Hitos', 'Participación en eventos', 'Convocatorias', 'Participación en otros espacios UNL [Expresiva, Idear, PTLC, Emprendedores, Otros]', 'Financiamiento']"
                  label="Tipo"
                  required
                  outlined
                ></v-select>
              </v-col>

              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="milestone_description"
                  label="Decripción"
                  outlined
                  required
                  :counter="300"
                  :maxlength="300"
                ></v-textarea>
              </v-col>
 
            </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="add_hito = false"
          >
            Cerrar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addMilestone"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'myIdea',

    data: () => ({
      edition_id:null,
      add_hito:false,
      aux:null, 
      show: false,

      id: null,
      title:null,
      description:null,

      vertical_works_id: 1,
      vertical_works:[],

      name:null,
      lastname:null,
      email:null,

      team:null,
      beneficiary_clients_users:null,
      problem:null,
      solution:null,
      innovation:null,
      market:null,
      value_proposal:null,
      channels_with_customers:null,
      revenue_model:null,
      activities_resources:null,
      investment_cost:null,
      competence:null,
      expected_impact:null,
      action_plan: null,

      development_degrees_id: 1,
      development_degree:[],

      development_degree_mdn_id: 1,
      development_degree_mdn:[],

      development_degree_ip_id: 1,
      development_degree_ip:[],
      
      entrepreneurship_stadia_id: 1,
      entrepreneurship_stadium:[],

      entrepreneurship_needs_2:[],
      entrepreneurship_needs:[],
      needs:[],

      milestone_id:100,
      milestone_type:'Hitos',
      milestone_description: '',

      headers: [
        { text: 'Tipo', value: 'type', width: '20%'},
        { text: 'Descripción', value: 'description', width: '50%' },
        { text: 'acciones', value: 'action' },
      ],
      curriculum_idea: [],

      name_school:null,
      address_school:null,
      phone_number_school:null,
      email_school:null,

      country_id:null,
      argentina_id:null,
      countries:[],

      provincia_id:22,
      provincias:[],

      localidad_id:1885,
      localidades:[],

      other_provincia:null,
      other_localidad:null,

      type_postulations_id: 1,
      type_postulations:[],

      editions:null,
      loading:true,
      btn_loading:false,
      confirm_dialog:false,
      dialog_error: false,
      errors:[]
    }),

    methods:{
      async getEntrepreneurshipStadium(){
        try {
          await axios.get('entrepreneurship-stadium').then(response =>{
            this.entrepreneurship_stadium = response.data.entrepreneurship_stadium
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getDevelopmentDegreeIP(){
        try {
          await axios.get('admin/development-degree-ip').then(response =>{
            this.development_degree_ip = response.data.data.development_degree
            console.log(this.development_degree_ip)
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getDevelopmentDegreeMDN(){
        try {
          await axios.get('admin/development-degree-mdn').then(response =>{
            this.development_degree_mdn = response.data.data.development_degree
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getVerticalWorks(){
        try {
          await axios.get('vertical-works').then(response =>{
            this.vertical_works = response.data.vertical_works
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getEntrepreneurshipNeeds(){
        try {
          await axios.get('entrepreneurship-needs').then(response =>{
            this.needs = response.data.entrepreneurship_needs
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },	

      async getCountries(){
        try {
          await axios.get('countries').then(response =>{
            this.countries = response.data.data.countries

            this.countries.forEach(element=>{
              if(element.name.toLowerCase()=='argentina'){
                this.argentina_id=element.id
                this.country_id = element.id
              }
            })
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getProvincias(){
        try {
          await axios.get('provincias').then(response =>{
            this.provincias = response.data.provincias
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidades(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
            this.localidad_id = response.data.provincia.localidads[0].id
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },

      async getLocalidadesCreated(){
        try {
          await axios.get('provincias-localidades/'+this.provincia_id).then(response =>{
            this.localidades = response.data.provincia.localidads
          }).catch(error => {
            console.log(error);
          })
          
        } catch (error) {
          console.log(error)
        }
      },

      async getTypePostulations(){
        try {
          await axios.get('type-postulations').then(response =>{
            this.type_postulations = response.data.data.type_postulations
          }).catch(error => {
            console.log(error);
          })
        } catch (error) {
          console.log(error)
        }
      },

      addMilestone(){
        let data = {  
                      'id': this.milestone_id,
                      'type':this.milestone_type, 
                      'description': this.milestone_description, 
                      'action':null 
                    };
        
        this.curriculum_idea.push(data)
        this.milestone_type = 'Hitos'
        this.milestone_description = ''
        this.add_hito = false
      },

      deleteMileston(index){
        this.curriculum_idea.splice(index, 1)
      },

      async createInvitation(){
        this.error = false
        this.errors = []
        this.loading = true
        this.confirm_dialog= false
        try {
          await axios.post('admin/edition/'+this.edition_id+'/entrepreneurships/add-entrepreneurship-edition',{

            type_postulations_id: this.type_postulations_id,
            title: this.title,
            description: this.description,
            vertical_works_id: this.vertical_works_id,
            team : this.team,
            beneficiary_clients_users: this.beneficiary_clients_users,

            problem: this.problem,
            solution: this.solution,
            innovation: this.innovation,

            market: this.market,
            value_proposal: this.value_proposal,
            channels_with_customers: this.channels_with_customers,
            revenue_model: this.revenue_model,
            activities_resources: this.activities_resources,
            investment_cost: this.investment_cost,
            competence: this.competence,
            expected_impact: this.expected_impact,
            action_plan: this.action_plan,

            curriculum_idea: this.curriculum_idea,

            entrepreneurship_stadia_id: this.entrepreneurship_stadia_id,
            development_degree_ip_id: this.development_degree_ip_id,
            development_degree_mdn_id: this.development_degree_mdn_id,

            country_id: this.country_id,
            provincia_id: this.provincia_id,
            localidad_id: this.localidad_id,

            other_provincia: this.other_provincia,
            other_localidad: this.other_localidad,

            name_school: this.name_school,
            address_school: this.address_school,
            phone_number_school: this.phone_number_school,
            email_school: this.email_school,

            edition_id: this.edition_id, 
            name: this.name, 
            lastname: this.lastname,
            email: this.email

          }).then(()=>{
            this.$router.push({ name: 'entrepreneurshipsEdition', params: { id: this.edition_id } }) 
          }).catch(error=>{
            this.loading = false
            console.log(error)
            Object.values(error.response.data.errors).forEach(error => {
              this.errors.push(error[0])
            })
          })
        } catch (error) {
          this.loading = false
          //console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          Object.values(error.response.data.errors).forEach(error => {
            this.errors.push(error)
          })
        }

        if(this.errors.length!=0){
          this.loading=false
          this.error=true
        }
      },
    },
    created(){
      this.edition_id = this.$route.params.edition_id;
      Promise.all([
        this.getTypePostulations(),
        this.getCountries(),
        this.getProvincias(),
        this.getLocalidadesCreated(),
        this.getEntrepreneurshipStadium(),
        this.getDevelopmentDegreeIP(),
        this.getDevelopmentDegreeMDN(),
        this.getVerticalWorks()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>